export class LFBackendDB {
    /* All Getters are expected to use Database object */
    async listDatabases() {
        throw TypeError('Not implemented');
    }

    async populateItems() {
        throw TypeError('Not implemented');
    }

    async createDatabase() {
        throw TypeError('Not implemented');
    }
}